import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import Checkbox from '../../../Base/Checkbox/Checkbox';
import ErrorMessage from '../ErrorMessage';
import TopFieldContent from '../TopFieldContent';
import InputWrapper from '../InputWrapper/InputWrapper';

interface InputFieldProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	isDisabled?: boolean;
	firstUpper?: boolean;
	className?: string;
	tx?: string;
	customOnChange?: (value: boolean) => void;
	description?: string;
	isWrapped?: boolean;
	hideRequired?: boolean;
	beforeLabelElement?: React.ReactElement | React.ReactElement[];
}

const CheckboxField = (props: InputFieldProps) => {
	const {
		name,
		label,
		isRequired,
		isDisabled = false,
		className,
		firstUpper = false,
		tx,
		customOnChange,
		description,
		isWrapped,
		hideRequired = false,
		beforeLabelElement,
	} = props;
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: false,
	});

	const component = (
		<div className={className}>
			{label && (
				<TopFieldContent
					label={label}
					isRequired={isRequired}
					hideRequired={hideRequired}
				/>
			)}
			<Checkbox
				tx={tx}
				{...field}
				firstUpper={firstUpper}
				disabled={isDisabled}
				onChangeExtra={customOnChange}
				description={description}
				beforeLabelElement={beforeLabelElement}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default CheckboxField;
